import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
// Base toastr styling. Kept global (before the overrides so those win) because
// 13 modules import `toastr` directly and render toasts without loading the
// stylesheet themselves — the lazy ../utils/toast wrapper only covers its own
// callers. Without this, the first toast on those pages renders unpositioned.
import "toastr/build/toastr.min.css";
import "./styles/toastr-overrides.css";


import "./index.css";
// Base styling for react-phone-number-input. Kept global because Checkout,
// Payment, PaymentStatus, IdleBehaviour and MembershipDealsModal all render
// <PhoneInput> without importing the stylesheet themselves.
import "react-phone-number-input/style.css";

import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { deferSentryInitialization } from "./utils/sentry";
import "./i18n";
import { SentryErrorBoundary } from "./ErrorBoundry";
import lazyWithRetry from "./utils/lazyWithRetry";
const Home = lazyWithRetry(() => import("./Home"));

const root = ReactDOM.createRoot(document.getElementById("root"));

// googleAnalytics stays out of the entry chunk: web-vitals callbacks fire
// after load, so loading the module on first callback costs nothing.
// Events land on window.dataLayer either way — nothing is dropped.
const trackPerformance = (obj) => {
  import("./utils/googleAnalytics").then(({ fireGtmEvent }) =>
    fireGtmEvent(obj?.name, { perfomanceObj: obj }),
  );
};

function MainApp() {
  return (
    // <CacheBuster
    //
    //   currentVersion={packageJson.version}
    //   isEnabled={true} //If false, the library is disabled.
    //   isVerboseMode={true} //If true, the library writes verbose logs to console.
    //   loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
    //   metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    // >
    <SentryErrorBoundary>
      <Provider store={store}>
        <Router>
          <Home />
        </Router>
      </Provider>
    </SentryErrorBoundary>
    // </CacheBuster>
  );
}
// const CacheClearedComponent = withClearCache(MainApp);
root.render(<MainApp />);
deferSentryInitialization();

// Enable service worker for instant repeat visitss
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      if (registration && registration.waiting) {
        // Skip waiting to activate new service worker
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
        // Don't auto-reload - let the new SW activate on next page load
        // This prevents interrupting users mid-action
        console.log('New version available! Will update on next page load.');
      }
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}

reportWebVitals(trackPerformance);
